<mat-spinner *ngIf="!loaded" diameter="50"></mat-spinner>

<form [formGroup]="form" *ngIf="form && loaded">
  <div class="save-header">
    <h2 data-test="title-bio" data-dd-privacy="allow">Your bio</h2>

    <div>
      <iris-button
        (click)="onCancel()"
        [disabled]="saving || form.pristine"
        [buttonType]="irisButtonTypes.SECONDARY"
        aria-label="Cancel"
        data-test="cancel-profile-info-changes"
      >
        Cancel
      </iris-button>
      <iris-button
        (click)="saveForm()"
        [disabled]="saving || form.pristine"
        aria-label="Save"
        data-test="save-profile-info-changes"
      >
        Save
      </iris-button>
    </div>
  </div>

  <div *ngIf="aiBio?.active" class="ai-bio-subheader">
    <div class="ai-bio-helper-text">
      <img src="/assets/images/two-stars.svg" alt=""/>
      <span class="iris-body-responsive">
        You now have the option to optimize your full bio with our personalized writing suggestions. Bios will be optimized on {{ optimizedDate | localizedDate:{ month: 'short', day: 'numeric', year: 'numeric' } }}, or you can choose to opt out before then if you do not wish to participate.
      </span>
    </div>
    <div class="ai-survey">
      <div class="iris-body-bold-responsive">We want to hear from you!</div>
      <span class="iris-body-responsive">
        We’re looking for feedback on optimized bios. <a target="_blank" [href]="bioSurveyLink" class="iris-link-primary-responsive">Take our quick survey</a>– it only takes 2 minutes.
      </span>
    </div>
  </div>

  <iris-card data-test="member-bio-card" class="card">
    <iris-form-field
      label="Mini bio"
      helperText="This is an opening sentence that directly answers the most common question from a potential client, “How can you help me?”"
    >
      <iris-text-input
        formControlName="searchBio"
        type="text"
        [maxLength]="shortBioMaxSize.toString()"
        data-test="mini-bio"
      >
      </iris-text-input>
      <iris-hint align="end">{{form.value?.searchBio?.length}} / {{shortBioMaxSize}}</iris-hint>
    </iris-form-field>


    <hr class="banner-break" *ngIf="!!optInStatus">
    <div class="banner opt-in" *ngIf="optInStatus === bioOptInStatus.OPTED_IN">
      <iris-icon name="check"></iris-icon>
      <div class="content">
        <div class="iris-body-bold">
          Your full bio was optimized!
        </div>
        <div class="iris-body-responsive">
          Thank you for participating. These changes will be seen by clients immediately. <a target="_blank" [href]="bioSurveyLink" class="iris-link-primary-responsive">Consider taking our quick survey</a> to give us feedback.
        </div>
      </div>
    </div>

    <div class="banner opt-out" *ngIf="optInStatus === bioOptInStatus.OPTED_OUT">
      <iris-icon name="check"></iris-icon>
      <div class="content">
        <div class="iris-body-bold">
          You opted out of using our optimized full bio.
        </div>
        <div class="iris-body-responsive">
          You can still edit your full bio if you choose. <a target="_blank" [href]="bioSurveyLink" class="iris-link-primary-responsive">Consider taking our quick survey</a> to give us feedback.
        </div>
        <div *ngIf="!showBioInBanner" class="expand" (click)="showBioInBanner = true">
          <span class="iris-body-bold">See our optimized suggestion again</span>
          <iris-icon name="expand_more"></iris-icon>
        </div>
        <div *ngIf="showBioInBanner" class="iris-body-responsive" [innerText]="aiBio?.enhancedText"></div>
      </div>
    </div>

    <iris-form-field
      *ngIf="!aiBio?.active"
      label="Full bio"
      helperText="Consider the following: Who is your ideal client? What are their issues, their needs, their goals? And importantly, how can you help? You may include areas of specialty or information about your background or your approach to care."
    >
      <iris-text-area
        formControlName="bio"
        [size]="textareaSizes.SM"
        data-test="full-bio"
      ></iris-text-area>
    </iris-form-field>

    <div
      *ngIf="aiBio?.active"
      class="ai-bio-section"
    >
      <h3 class="iris-h3-responsive iris-mb-01">Full bio</h3>
      <span class="iris-body-responsive iris-mb-05 ideal-client">Consider the following: Who is your ideal client? What are their issues, their needs, their goals? And importantly, how can you help? You may include areas of specialty or information about your background or your approach to care.</span>
      <div class="bio-grid">
        <div class="ai-bio-container">
          <span class="iris-body-bold-responsive">Our optimized suggestion for your full bio</span>
          <div class="ai-bio iris-body-responsive"
            [innerText]="aiBio.enhancedText">
          </div>
          <div class="decision-container">
            <span class="iris-body-bold-responsive">
              Would you like to use this full bio instead of your current?
            </span>
            <div class="button-container">
              <iris-button
                (click)="useSuggestedBio()"
                [buttonType]="irisButtonTypes.PRIMARY"
                [disabled]="saving"
                aria-label="use-suggested-full-bio"
              >
                Yes, use the suggested full bio
              </iris-button>
              <iris-button
                (click)="useCurrentBio()"
                [buttonType]="irisButtonTypes.SECONDARY"
                [disabled]="saving"
                aria-label="opt-out"
              >
                Opt out – do not change my full bio
              </iris-button>
            </div>
            <span class="iris-legal-responsive auto-message">
              Please note: if you take no action, your full bio will be automatically updated to our suggestion on {{ optimizedDate | localizedDate:{ month: 'short', day: 'numeric', year: 'numeric' } }}.
            </span>
          </div>
        </div>
        <div class="current-bio-container">
          <span class="iris-body-bold-responsive">Your current full bio</span>
          <div class="current-bio iris-body-responsive"
            [innerText]="form.value?.bio">
          </div>
        </div>
      </div>
    </div>
  </iris-card>
</form>
